import { cx } from '@emotion/css';
import { StoreTwoTone } from '@mui/icons-material';
import { useMediaQuery } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { FC } from 'react';

import { usePublicAppContext } from '_core/context/public-app-context';
import { agencyClaimConfig } from '_features/agency/claim/agency-claim.config';
import { AgencyAutocomplete, StepsBar } from '_features/agency/claim/components';

import { AgenciesAutocompletePayload } from '../../../core/repos/agencies-autocomplete.repo';
import { agencyRepo } from '../../../core/repos/agency.repo';

export const AgencyClaimLandingPage: FC = () => {
  const { getUrl } = usePublicAppContext();
  const { media_legacy } = useMediaQuery();
  const { t } = useTranslation(agencyClaimConfig.i18nNamespaces);

  const onSelectedAgency = async (fragment: string, item: AgenciesAutocompletePayload) => {
    const { slug: agencySlug } = item ?? {};

    if (agencySlug) {
      const agency = await agencyRepo.getAgency({ agencySlugOrUuid: agencySlug });
      window.location.href = getUrl('agency.claim.confirm', { slugOrUuid: agency.uuid || agency.slug });
    } else {
      window.location.href = getUrl('agency.claim.confirm', { name: fragment });
    }
  };

  return (
    <div className="overflow-hidden layout-fill layout-column">
      <StepsBar activeStep={1} />
      <div className="flex-1 overflow-auto bg-secondary-50 layout-column layout-align-start-center">
        <div
          className={cx('sm:px-8 py-8 max-sm:px-4 flex-noshrink layout-column layout-align-start-center text-center')}>
          <div className="mt-8 layout-column layout-align-center-center">
            <div className="bg-secondary-300 p-2 rounded-md layout-column layout-align-center-center">
              <StoreTwoTone className="text-secondary-700" style={{ fontSize: 24 }} />
            </div>
            <h1 className={cx({ h3: media_legacy.xs }, 'bold mt-8')}>{t('agency:claim.landing.title_V2')}</h1>
            <p className="mt-4 mb-8 h6 text-secondary-500">{t('agency:claim.landing.subtitle_V3')}</p>
            <AgencyAutocomplete id={'agency-claim-lookup'} onSelected={onSelectedAgency} />
          </div>
        </div>
      </div>
    </div>
  );
};
